import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NgxMetaPixelService } from 'ngx-meta-pixel';
import { AuthService } from './auth.service';
import { environment } from '../environments/environment';

declare var fbq: any;

@Injectable({
  providedIn: 'root'
})
export class TrackingService {

  private userData: any = {};

  constructor(
    private ngxPixelService: NgxMetaPixelService,
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { 
    if (isPlatformBrowser(this.platformId)) {
        this.authService.getUserChanges().subscribe(user => {
            if (user) {
                this.userData = {
                    em: user.email,
                    fn: user.name,
                    ph: user.phone,
                    external_id: user.id
                };
            } else {
                this.userData = {};
            }
        });
    }
  }

  track(eventName: string, properties?: any) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    if (!environment.production) {
      return;
    }

    if (typeof fbq === 'undefined') {
      return;
    }

    const finalProperties = { ...properties, ...this.userData };
    fbq('track', eventName, finalProperties);
  }

  trackCustom(eventName: string, properties?: any) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    if (!environment.production) {
      return;
    }

    const finalProperties = { ...properties, ...this.userData };
    this.ngxPixelService.trackCustom(eventName, finalProperties);
  }
}
